import { JovivaService } from '~/components/JovivaServicesNavigation/constants'

export const URL_PARAM_KEYS = {
  serviceTypeId: 'serviceTypeId',
  roomId: 'roomId',
  date: 'date',
  employeeId: 'employeeId',
  storeId: 'storeId',
  start: 'start',
  end: 'end',
  appointmentId: 'appointmentId',
  calendarView: 'calendarView',
  recipient: 'recipient',
  token: 'token',
}

export const CANCELLATION_CATEGORIES = {
  appointment: 'mein-joviva-cancel-appointment',
}

export const EXTRA_FEATURES = [
  JovivaService.PHONE,
  JovivaService.CONTRACT_MANAGEMENT,
  JovivaService.PAGE_BUILDER,
  JovivaService.CUSTOMER,
  JovivaService.ARTICLE_INVENTORY,
]
